import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';

import { HeaderSummaryComponent } from '@ruby/shared/inventory-management/header-summary/header-summary.component';

@NgModule({
  declarations: [HeaderSummaryComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDatepickerModule,
    FormsModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatToolbarModule,
    ReactiveFormsModule
  ],
  exports: [HeaderSummaryComponent]
})
export class HeaderSummaryModule {}
